import type { DirectionDxDy } from "./DirectionDxDy.type"

export const DIRECTION_DXDY_NORTH_EAST = { dx: 1, dy: -1 }
export const DIRECTION_DXDY_SOUTH_EAST = { dx: 1, dy: 1 }
export const DIRECTION_DXDY_NORTH_WEST = { dx: -1, dy: -1 }
export const DIRECTION_DXDY_SOUTH_WEST = { dx: -1, dy: 1 }

const diagonalDirections: ReadonlyArray<DirectionDxDy> = [
  DIRECTION_DXDY_SOUTH_EAST,
  DIRECTION_DXDY_NORTH_EAST,
  DIRECTION_DXDY_NORTH_WEST,
  DIRECTION_DXDY_SOUTH_WEST,
] as const

export default diagonalDirections

